/**
 * Google Analytics (GA4) – minimal utility for React SPA.
 * Requires REACT_APP_GA_MEASUREMENT_ID (e.g. G-XXXXXXXXXX) in .env
 */

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const GTAG_URL = 'https://www.googletagmanager.com/gtag/js';

let isInitialized = false;

/**
 * Loads gtag script and configures the property with measurementId.
 * Only runs if REACT_APP_GA_MEASUREMENT_ID is defined.
 */
export function init() {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined') return;

  if (isInitialized) return;
  isInitialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());

  const script = document.createElement('script');
  script.async = true;
  script.src = `${GTAG_URL}?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false // we send page_view on each route change
  });
}

/**
 * Sends a page_view to GA4 (for SPA route tracking).
 * @param {string} [path] - page_path (default: location.pathname + search)
 * @param {string} [title] - page_title (default: document.title)
 */
export function pageView(path, title) {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined' || !window.gtag) return;

  window.gtag('event', 'page_view', {
    page_path: path ?? window.location.pathname + window.location.search,
    page_title: title ?? document.title
  });
}

/**
 * Sends a custom event to GA4.
 * @param {string} name - Event name (e.g. 'click_cta', 'submit_form')
 * @param {Object} [params] - Event parameters
 */
export function event(name, params = {}) {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined' || !window.gtag) return;

  window.gtag('event', name, params);
}

export { GA_MEASUREMENT_ID };
